import isEmpty from 'lodash.isempty';
import getProfileFeedbackHeroImages from 'helpers/getProfileFeedbackHeroImages';

const getProfileReviewsMetaDataProps = (profile) => {
  const {
    primaryServiceType: { personForm: serviceName },
    city: {
      name: cityName,
      displayName: cityDisplayName,
      stateOrProvince: { name: stateDisplayName },
    },
    mainProfileIconUrl,
    profileName,
    profileUrl,
    countryName,
  } = profile;

  const openGraphProps = {
    type: 'website',
    image: mainProfileIconUrl,
    title: `${profileName} Reviews`,
    url: `https://${profileUrl}/feedback`,
    location: cityName,
    state: stateDisplayName,
    country: countryName,
    description: `${profileName} Reviews - ${serviceName} ${cityDisplayName}`,
  };

  const description = `Want to book ${profileName} for your event? See what others are saying! See reviews for this ${serviceName} here.`;

  const title = `${profileName} Reviews - ${serviceName} ${cityDisplayName}`;

  let desktopHeroImageUrl = null;
  let mobileHeroImageUrl = null;
  const { thumbnailUrl } = profile;

  if (!isEmpty(thumbnailUrl)) {
    const profileHeroImages = getProfileFeedbackHeroImages(thumbnailUrl);
    desktopHeroImageUrl = `${profileHeroImages.desktop}?quality=50`;
    mobileHeroImageUrl = `${profileHeroImages.mobile}?quality=50`;
  }

  return {
    description,
    title,
    openGraphProps,
    desktopHeroImageUrl,
    mobileHeroImageUrl,
    canonicalUrlOverride: profileUrl,
  };
};

export default getProfileReviewsMetaDataProps;
